import { PitcherSingleSessionReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const PitcherSingleSessionPitchByPitchStatsChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='PitcherSingleSessionPitchByPitchStatsChart'
      configKey='pitcherSingleSessionPitchByPitchStatsChartConfig'
      {...props}
    />
  );
};

export default PitcherSingleSessionPitchByPitchStatsChartSidebar;
